import React, { useState, useMemo } from 'react';
import moment from 'moment';

import CoreStep from './CoreStep';
import { useDispatch, useSelector } from 'react-redux';
import { updateAttribute } from '@/actions/DirectQuoteActions';
import Input from '@/elements/Input';
import ExistingQuotesList from '../Partials/ExistingQuotesList';

export default function When({
    progressBlock,
    title,
    progressTitle,
    stepsToSkipNext = false,
    stepsToSkipPrev = false,
    isLastStep = false,
    stepName = null,
}) {
    const dispatch = useDispatch();
    const [editMealDate, setEditMealDate] = useState(true);
    const directQuote = useSelector((state) => state.directQuote);
    // const [editMealDate, setEditMealDate] = useState(() => directQuote.quote.mealDate ? false : true);

    const formattedMealDate = useMemo(() => {
        // Use moment to parse in local time for correct timezone handling
        return moment(directQuote.quote.mealDate).format('D MMMM YYYY');
    }, [directQuote.quote.mealDate]);

    const handleEditMealDate = () => {
        setEditMealDate(true);
    };

    // Format date as YYYY-MM-DD using moment to avoid UTC timezone shift
    // (toISOString() converts to UTC which can shift the date by one day)
    const updateMealDate = (mealDate) => {
        if (!mealDate) return;

        // Use moment to format in local time, not UTC
        const formattedDate = moment(mealDate).format('YYYY-MM-DD');

        dispatch(updateAttribute('mealDate', formattedDate));
    };

    const hasExistingQuotesOnSameDay =
        directQuote?.existingQuotes?.filter((quote) => {
            return quote.meal_date == directQuote?.quote?.mealDate;
        })?.length > 0;

    const isValid = () => {
        if (!directQuote.quote.mealDate || hasExistingQuotesOnSameDay) {
            return false;
        } else {
            return true;
        }
    };

    const renderStep = () => {
        return (
            <>
                <div className={`${editMealDate ? '' : 'form-group -edit'}`}>
                    <div className="form-item">
                        {editMealDate ? (
                            <Input
                                label="Event date"
                                inputType="event-date"
                                value={directQuote.quote.mealDate}
                                handleChange={updateMealDate}
                                unavailableDates={false}
                                icon={<i className="yh-new-icon-Calendar" />}
                                inputClass="-unstyled"
                            />
                        ) : (
                            <>
                                <label>Event date</label>
                                <span className="details">
                                    {formattedMealDate}
                                </span>
                            </>
                        )}
                    </div>
                    {!editMealDate && (
                        <div className="form-edit" onClick={handleEditMealDate}>
                            Edit
                        </div>
                    )}
                </div>
                {hasExistingQuotesOnSameDay && (
                    <>
                        <div className="alert alert-secondary" role="alert">
                            You already have an open quote on this date, please
                            select a different date or you can invite this chef
                            to your existing quote.
                        </div>
                        <ExistingQuotesList />
                    </>
                )}
            </>
        );
    };

    return (
        <CoreStep
            title={title}
            isValid={isValid}
            stepName={stepName}
            renderStep={renderStep}
            isLastStep={isLastStep}
            progressBlock={progressBlock}
            progressTitle={progressTitle}
            stepsToSkipNext={stepsToSkipNext}
            stepsToSkipPrev={stepsToSkipPrev}
        />
    );
}
